export const home = {
    title1:'Hogar',
    title2:'Sector',
    title3:'Productos',
    title4:'Cuestionario ',
    title5:'language',
    welcome:'Bienvenido a este sitio web',
    login:'Inicio/registro'
}
export const center = {
    title1:'Sobre nosotros',
    title2:'Presentación departamental',
    title3:'Presentación del producto',
    more:'Más',
    titlex:'Cuestionario'
}

export const bottom = {
    address:'Dirección',
    email:'Buzón de correo',
    phone:'Teléfono',
    Postal :'Código postal'
}
export const paper = {
    submit:'Confirmación de la presentación',
    btn:'Participación en actividades',
    tips:'Presentación exitosa'
}
export const login = {
    title:'Inicio de sesión de la cuenta',
    email:'Buzón',
    pwd:'Contraseña',
    titlel:'Registro ',
    titler:'contraseña',
    btn:'Iniciar sesión'
}
export const register = {
    title:'Registro de cuentas',
    code:'Código',
    email:'Buzón',
    pwd:'antigua',
    pwd2:'Contraseña',
    titlel:'Inicio de sesión de la cuenta',
    titler:'Olvida la contraseña.',
    btn:'Registro',
    codeTips:'Obtener Código'
}
export const forgot = {
    title:'Olvida la contraseña.',
    code:'Código',
    email:'Buzón',
    pwd:'Nueva ',
    pwd2:'Confirmar',
    titlel:'Inicio de sesión de la cuenta',
    titler:'Olvida la contraseña.',
    btn:'Confirmar cambios',
    codeTips:'Obtener Código'
}
export const active = {
    tips:'¡El Sr. Zhang recibió un premio de $100 a través del cuestionario!',
    title1:'Regístrese ahora',
    title2:'Completar la tarea de inicio de sesión',
    title3:'Ganar un premio de $50',
    title4:'Participación',
    title22:'Completar la tarea de registro',
    title23:'Completar la tarea de actualización',
    popup1:'Registro exitoso, 100 dólares de recompensa; ¡Ve a hacer otra tarea!',
    popup2:'Firmar hoy para recibir 20 puntos',
    popup3:'¡Lo siento, el nivel actual de membresía no es suficiente, no puede entrar en la tarea correspondiente, por favor póngase en contacto con el Servicio de atención al cliente inmediatamente!',
    popup1Btn:'Ya veo.',
    popup2Btn:'Ya veo.',
    popup3Btn:'Contacto con el servicio al cliente',
}


// WEBPACK FOOTER //
// ./src/i18n/Spanish.js